export default __webpack_public_path__ + "static/media/image47.ef005a2e.png";